module.exports = __webpack_public_path__ + "static/media/TilaaTaksi_099.5f89ac88.jpg";